import { Injectable } from '@angular/core';
import { CLOCKIN_LINETYPE_OPTIONS } from '../../shared/constants/dropdown.constant';
import { PortalSettingsService } from './portal-settings.service';
import { LineType } from '../../shared/model/line-type.model';

@Injectable({
  providedIn: 'root',
})
export class ClockInOutService {
  portalSettings: any;
  constructor(portalSettingsService: PortalSettingsService) {
    portalSettingsService.portalSettings$.subscribe(latestSettings => {
      this.portalSettings = latestSettings;
    });
  }

  public getEnabledLineTypes(licensedUser: any, isActiveTechnician: boolean): LineType[] {
    const enabledLineTypesInClockIn = this.portalSettings.EnabledLineTypesInClockIn.ConfigValue;
    let lineTypes = [];
    if (enabledLineTypesInClockIn != null) {
      const allLineTypes = CLOCKIN_LINETYPE_OPTIONS;
      const enabledLineTypesInClockInList = enabledLineTypesInClockIn.split(',');
      lineTypes = allLineTypes.filter(lineType => {
        const isEnabled = enabledLineTypesInClockInList.includes(lineType.Value);
        const isJob = lineType.Value == 'J';
        const isSMWorkOrder =
          lineType.Value == 'S' &&
          isActiveTechnician &&
          (licensedUser?.fieldServiceCount == '1' || licensedUser?.userCount == '1' || licensedUser?.fieldUserCount == '1');
        return isEnabled && (isJob || isSMWorkOrder);
      });
    }
    return lineTypes;
  }
}
